import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from 'components/Header';




const DefaultLayout = (props) => {
  return (
    <div>
      <Header />

      <ContentContainer>
        { props.children }
      </ContentContainer>
    </div>
  )
}

export default DefaultLayout;




const ContentContainer = styled.div`
  margin-top: 100px;
  max-width: 500px;
  margin: 0 auto;
  padding: 30px 40px;

  background: rgb(25, 27, 31);
  box-shadow: rgb(0 0 0 / 1%) 0px 0px 1px, rgb(0 0 0 / 4%) 0px 4px 8px, rgb(0 0 0 / 4%) 0px 16px 24px, rgb(0 0 0 / 1%) 0px 24px 32px;
  border-radius: 10px;
  margin-top: 20px;
  min-height: 100px;

`;

